
export default function WhistlerCTA() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  const benefits = [
    'Zoning verification and compliance review',
    'Business license application assistance',
    'Strata bylaw navigation support',
    'Revenue optimization strategies',
    'Seasonal pricing management',
    'Local market expertise',
  ];

  return (
    <section
      id="contact"
      className="py-24 lg:py-32 bg-gradient-to-br from-[#882629] to-[#6E1F22] relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-white mb-6">
          Start Your Whistler STR Journey Today
        </h2>

        <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Let us handle Whistler&apos;s unique STR regulations while you maximize your rental income.
          Our local expertise ensures you stay compliant and profitable in this world-class resort destination.
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-12 max-w-3xl mx-auto">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl px-6 py-4 text-left"
            >
              <i className="ri-checkbox-circle-fill text-2xl text-white flex-shrink-0"></i>
              <span className="text-base text-white font-medium">{benefit}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <button
            onClick={handleAssessment}
            className="bg-white text-[#882629] px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#F0F0F0] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
          >
            Get Whistler Compliance Help
          </button>

          <a
            href="tel:+17783869229"
            className="bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap border-2 border-white/30 flex items-center gap-3"
          >
            <i className="ri-phone-line text-xl"></i>
            +1 (778) 386-9229
          </a>
        </div>

        <p className="text-sm text-white/70">
          Serving Whistler property owners • Expert STR compliance management
        </p>
      </div>
    </section>
  );
}
